import React, { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { LANGS } from "@/i18n/translations";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} data-testid="language-switcher-button" title={current.label}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border border-[#243047] bg-[#121824] text-[#94A3B8] hover:text-white hover:border-[#00FFC2]/60 transition text-sm">
        <Globe className="w-4 h-4 text-[#00FFC2]" />
        <span className="font-mono font-bold uppercase text-xs">{current.code}</span>
      </button>
      {open && (
        <div data-testid="language-menu" className="absolute right-0 mt-2 w-40 rounded-xl border border-[#243047] bg-[#0A0D14] shadow-[0_10px_40px_rgba(0,0,0,0.6)] overflow-hidden fade-up z-[60]">
          {LANGS.map((l) => (
            <button key={l.code} onClick={() => { setLang(l.code); setOpen(false); }} data-testid={`language-option-${l.code}`}
              className={`w-full flex items-center justify-between px-3 py-2.5 text-sm transition ${
                l.code === lang ? "bg-gradient-to-r from-[#EC1E9C]/20 to-[#00FFC2]/20 text-white" : "text-[#94A3B8] hover:text-white hover:bg-[#121824]"
              }`}>
              <span className="flex items-center gap-2"><span>{l.flag}</span>{l.label}</span>
              {l.code === lang && <Check className="w-4 h-4 text-[#00FFC2]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
